


import {
  UserIcon,
  Building2Icon,
  SearchIcon,
  ShieldCheckIcon,
  LucideIcon,
} from 'lucide-react'

export type PersonaKey = 'seeker' | 'employer' | 'recruiter' | 'admin'

export interface Persona {
  key: PersonaKey
  label: string
  name: string
  role: string
  icon: LucideIcon
  metrics: { label: string; value: string; delta?: string }[]
  panels: DashboardPanel[]
}

export interface DashboardPanel {
  title: string
  type: 'list' | 'progress' | 'activity'
  items: PanelItem[]
}

export interface PanelItem {
  primary: string
  secondary?: string
  meta?: string
  status?: 'active' | 'pending' | 'closed'
  progress?: number
}

export const personas: Persona[] = [
  {
    key: 'seeker',
    label: 'Job Seeker',
    name: 'Alexandra Reid',
    role: 'CFO Candidate',
    icon: UserIcon,
    metrics: [
      { label: 'Active applications', value: '4', delta: '+1 this week' },
      { label: 'Profile views', value: '218', delta: '+32%' },
      { label: 'Saved roles', value: '7' },
      { label: 'Interviews', value: '2' },
    ],
    panels: [
      {
        title: 'Your applications',
        type: 'list',
        items: [
          { primary: 'Chief Financial Officer', secondary: 'Northwind Capital', meta: 'Final stage', status: 'active' },
          { primary: 'Interim CFO', secondary: 'Brightline Retail', meta: 'In review', status: 'pending' },
          { primary: 'Group Finance Director', secondary: 'Confidential', meta: 'Shortlisted', status: 'active' },
          { primary: 'CFO', secondary: 'Vantage Health', meta: 'Not progressed', status: 'closed' },
        ],
      },
      {
        title: 'Profile strength',
        type: 'progress',
        items: [
          { primary: 'Executive summary', progress: 100 },
          { primary: 'Experience & achievements', progress: 90 },
          { primary: 'References', progress: 60 },
          { primary: 'Compensation preferences', progress: 40 },
        ],
      },
    ],
  },
  {
    key: 'employer',
    label: 'Employer',
    name: 'Marcus Devlin',
    role: 'Managing Partner, Northwind',
    icon: Building2Icon,
    metrics: [
      { label: 'Open mandates', value: '3' },
      { label: 'Candidates in play', value: '27', delta: '+6' },
      { label: 'Interviews scheduled', value: '9' },
      { label: 'Avg. time to shortlist', value: '18d' },
    ],
    panels: [
      {
        title: 'Active searches',
        type: 'list',
        items: [
          { primary: 'Chief Financial Officer', secondary: 'New York', meta: '12 candidates', status: 'active' },
          { primary: 'Head of Portfolio Ops', secondary: 'New York', meta: '9 candidates', status: 'active' },
          { primary: 'VP Investor Relations', secondary: 'Remote', meta: '6 candidates', status: 'pending' },
        ],
      },
      {
        title: 'Recent activity',
        type: 'activity',
        items: [
          { primary: 'New shortlist delivered', secondary: 'CFO search', meta: '2h ago' },
          { primary: 'Interview feedback requested', secondary: 'A. Reid', meta: 'Yesterday' },
          { primary: 'Offer approved', secondary: 'Head of Ops', meta: '3 days ago' },
        ],
      },
    ],
  },
  {
    key: 'recruiter',
    label: 'Recruiter',
    name: 'Sofia Marchetti',
    role: 'Partner, Ardent',
    icon: SearchIcon,
    metrics: [
      { label: 'Live mandates', value: '11' },
      { label: 'Candidates sourced', value: '146', delta: '+24' },
      { label: 'Placements (QTD)', value: '5' },
      { label: 'Pipeline health', value: '92%' },
    ],
    panels: [
      {
        title: 'Mandate pipeline',
        type: 'list',
        items: [
          { primary: 'CEO — Lumen Renewables', secondary: 'London', meta: 'Assessment', status: 'active' },
          { primary: 'CTO — Vantage Health', secondary: 'Remote', meta: 'Research', status: 'active' },
          { primary: 'CMO — Maison Atelier', secondary: 'Paris', meta: 'Shortlist', status: 'pending' },
          { primary: 'GC — Helios Bank', secondary: 'Dubai', meta: 'Offer', status: 'active' },
        ],
      },
      {
        title: 'Today\u2019s priorities',
        type: 'activity',
        items: [
          { primary: 'Client debrief — Lumen', secondary: 'Board chair', meta: '11:00' },
          { primary: 'Assess 3 CTO candidates', secondary: 'Vantage', meta: '14:00' },
          { primary: 'Reference checks', secondary: 'Helios GC', meta: '16:30' },
        ],
      },
    ],
  },
  {
    key: 'admin',
    label: 'Administrator',
    name: 'Operations Console',
    role: 'Platform Admin',
    icon: ShieldCheckIcon,
    metrics: [
      { label: 'Active users', value: '4,812', delta: '+3.4%' },
      { label: 'Live mandates', value: '186' },
      { label: 'Applications (30d)', value: '9,240' },
      { label: 'Uptime', value: '99.98%' },
    ],
    panels: [
      {
        title: 'System health',
        type: 'progress',
        items: [
          { primary: 'Search API', progress: 99 },
          { primary: 'Matching engine', progress: 96 },
          { primary: 'Messaging service', progress: 100 },
          { primary: 'Assessment module', progress: 88 },
        ],
      },
      {
        title: 'Moderation queue',
        type: 'list',
        items: [
          { primary: 'New employer verification', secondary: 'Cascade Mfg.', meta: 'Pending', status: 'pending' },
          { primary: 'Flagged listing review', secondary: '2 reports', meta: 'Review', status: 'pending' },
          { primary: 'Bulk candidate import', secondary: '412 records', meta: 'Complete', status: 'active' },
        ],
      },
    ],
  },
]

export const personaIcons = { UserIcon, Building2Icon, SearchIcon, ShieldCheckIcon }


